module.exports = __webpack_public_path__ + "img/deione-circle.f9468e09.png";